import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toOrdinalNumber',
  pure: true
})
export class ToOrdinalNumberPipe implements PipeTransform {
  transform(htmlText: string): string {
    if (`${+htmlText}` === 'undefined' || htmlText === '') {
      return '';
    }

    const lastTwoDigits = +htmlText % 100;
    const lastDigit = +htmlText % 10;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
      return `${htmlText}th`;
    }

    switch (lastDigit) {
      case 1:
        return `${htmlText}st`;
      case 2:
        return `${htmlText}nd`;
      case 3:
        return `${htmlText}rd`;
      default:
        return `${htmlText}th`;
    }
  }
}
